@switch (contentType) {
  @case ('string') {
    <div class="box">
      <div [innerHTML]="stringContent"></div>
    </div>
  }
  @case ('template') {
    <ng-container *ngTemplateOutlet="templateContent!; context: context" />
  }
  @case ('component') {
    <ng-container *ngComponentOutlet="componentContent!" />
  }
}
<mat-spinner />
